import React, {useEffect} from 'react'
import {useLocalizedNavigate} from 'i18n/useLocalizedNavigate'
import {routes} from 'routes/routes'
import {useQueryParams} from 'utils/lib/url'
import {ResetPassword} from 'organization/Auth/PasswordRecover/ResetPassword'
import {RequestReset} from 'organization/Auth/PasswordRecover/RequestReset'
import {useOrganizationAuth} from 'organization/Auth/Providers/OrganizationAuthProvider'

export function PasswordRecover() {
  const {token} = useQueryParams()

  const navigate = useLocalizedNavigate()
  const {user} = useOrganizationAuth()

  useEffect(() => {
    if (user) {
      navigate(routes.index)
    }
  }, [navigate, user])

  if (token) {
    return <ResetPassword />
  }

  return <RequestReset />
}
